module.exports = __webpack_public_path__ + "img/props-zh_cn.cc570925.png";